import { SubmitButton } from '../../../SubmitButton';
import { useSavedPaymentMethodButton } from '../../hooks/useSavedPaymentMethodButton';

type Props = {
	selectedPaymentMethod: string | null;
};

export const SubmitButtonWrapper: React.FC<Props> = ({ selectedPaymentMethod }) => {
	const {
		data: { loading },
		actions: { onClick },
	} = useSavedPaymentMethodButton();

	if (selectedPaymentMethod !== 'creditCard' && selectedPaymentMethod !== 'sepa') {
		return null;
	}

	return (
		<div className="w-full">
			<SubmitButton disabled={loading} loading={loading} onClick={async () => onClick(selectedPaymentMethod)} />
		</div>
	);
};
